var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 134,
    viewBox: "0 0 227 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M211.646 118.579H198.053L197.445 95.5225H211.104L211.563 115.082L211.646 118.579Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M29.5346 95.5225L28.9272 118.579H15.332L15.4158 115.082L15.8746 95.5225H29.5346Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.706 121.147H15.2695L15.3186 119.137L15.3332 118.579L15.3399 118.244L15.4147 115.087L15.8199 97.8124L15.8735 95.526L16.5087 68.4606L16.5277 67.6155L17.7334 16.1071C17.7334 7.4217 25.2968 0.366211 34.6141 0.366211H192.358C201.687 0.366211 209.239 7.42394 209.239 16.1071L211.099 95.5249L211.152 97.8113L211.557 115.086L211.632 118.243L211.641 118.578L211.652 119.136L211.706 121.147Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.057 118.766H28.9258V118.58L29.4739 97.8091L29.5353 95.5227L31.3081 28.1517L31.4387 23.128C31.4387 20.4297 32.2202 17.9469 33.6012 15.9832C33.9677 15.4598 34.3818 14.9714 34.8381 14.5241C36.679 12.7089 39.1808 11.6104 42.118 11.6104H184.022C185.534 11.6099 187.032 11.9075 188.43 12.4861C189.828 13.0648 191.098 13.9131 192.168 14.9827C193.237 16.0522 194.086 17.3221 194.665 18.7197C195.244 20.1173 195.542 21.6153 195.541 23.128L195.672 28.1517L197.445 95.5227L197.506 97.8091L198.022 117.405L198.054 118.58L198.057 118.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M199.227 117.403H198.025L197.449 95.5223L195.543 23.1243C195.543 21.6116 195.245 20.1138 194.666 18.7163C194.087 17.3188 193.238 16.0491 192.169 14.9796C191.099 13.9101 189.829 13.0617 188.431 12.483C187.034 11.9043 185.536 11.6065 184.023 11.6066H42.1208C39.1837 11.6066 36.6807 12.7062 34.8398 14.5204C36.7165 11.9125 39.6726 10.2446 43.2886 10.2446H185.191C186.704 10.2445 188.202 10.5423 189.599 11.121C190.997 11.6998 192.267 12.5481 193.336 13.6176C194.406 14.6871 195.255 15.9569 195.834 17.3543C196.413 18.7518 196.711 20.2496 196.711 21.7623L198.617 94.1603L199.224 117.217L199.227 117.403Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.952 123.377L224.868 127.881L224.467 129.522L224.253 130.39C224.029 131.302 223.506 132.113 222.766 132.691C222.027 133.27 221.115 133.584 220.176 133.582H7.0875C6.17441 133.582 5.28617 133.285 4.55665 132.736C3.82712 132.187 3.29584 131.415 3.04287 130.538L2.7649 129.522L2.29825 127.881L1.07023 123.527C0.315565 120.877 2.32393 118.243 5.10482 118.243H221.875C224.59 118.241 226.59 120.759 225.952 123.377Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M224.344 129.52L224.134 130.389C223.909 131.301 223.385 132.111 222.646 132.689C221.906 133.268 220.994 133.581 220.055 133.58H6.96658C6.0537 133.58 5.16552 133.283 4.43638 132.734C3.70724 132.185 3.17681 131.413 2.92531 130.536L2.64062 129.519L224.344 129.52Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.2348 37.9956H53.2402C50.4022 37.9956 48.1016 40.2963 48.1016 43.1343V50.3863C48.1016 53.2243 50.4022 55.5249 53.2402 55.5249H78.2348C81.0728 55.5249 83.3734 53.2243 83.3734 50.3863V43.1343C83.3734 40.2963 81.0728 37.9956 78.2348 37.9956Z",
    fill: "#9A9EB1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.2348 64.6182H53.2402C50.4022 64.6182 48.1016 66.9188 48.1016 69.7568V77.0088C48.1016 79.8468 50.4022 82.1475 53.2402 82.1475H78.2348C81.0728 82.1475 83.3734 79.8468 83.3734 77.0088V69.7568C83.3734 66.9188 81.0728 64.6182 78.2348 64.6182Z",
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.2348 89.0435H53.2402C50.4022 89.0435 48.1016 91.3441 48.1016 94.1821V101.434C48.1016 104.272 50.4022 106.573 53.2402 106.573H78.2348C81.0728 106.573 83.3734 104.272 83.3734 101.434V94.1821C83.3734 91.3441 81.0728 89.0435 78.2348 89.0435Z",
    fill: "#9A9EB1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M167.251 39.8545H105.979C103.751 39.8545 101.945 41.6603 101.945 43.888C101.945 46.1156 103.751 47.9214 105.979 47.9214H167.251C169.479 47.9214 171.284 46.1156 171.284 43.888C171.284 41.6603 169.479 39.8545 167.251 39.8545Z",
    fill: "#D8D8DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M145.907 54.6777H105.926C103.728 54.6777 101.945 56.4601 101.945 58.6587V58.7637C101.945 60.9623 103.728 62.7447 105.926 62.7447H145.907C148.106 62.7447 149.888 60.9623 149.888 58.7637V58.6587C149.888 56.4601 148.106 54.6777 145.907 54.6777Z",
    fill: "#D8D8DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M105.979 87.0806L167.252 87.0806C169.479 87.0806 171.285 85.2747 171.285 83.0471C171.285 80.8195 169.479 79.0136 167.252 79.0136L105.979 79.0136C103.752 79.0136 101.946 80.8195 101.946 83.0471C101.946 85.2747 103.752 87.0806 105.979 87.0806Z",
    fill: "#D8D8DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M127.323 101.904H167.304C169.503 101.904 171.285 100.121 171.285 97.9228V97.8179C171.285 95.6192 169.503 93.8369 167.304 93.8369H127.323C125.125 93.8369 123.342 95.6192 123.342 97.8179V97.9228C123.342 100.121 125.125 101.904 127.323 101.904Z",
    fill: "#D8D8DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 204.545,
    y1: 91.3483,
    x2: 204.545,
    y2: 129.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20676.7,
    y1: 18961.7,
    x2: 20676.7,
    y2: 26900.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 113.487,
    y1: 119.672,
    x2: 113.487,
    y2: 8.23777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 335107,
    y1: 276797,
    x2: 467676,
    y2: 128458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 190.809,
    y1: 125.91,
    x2: -70.4247,
    y2: 125.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 703749,
    y1: 11623.6,
    x2: 39270.7,
    y2: 11623.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BCBE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225.173,
    height: 133.63,
    fill: "white",
    transform: "translate(0.914062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMobile);
export default __webpack_public_path__ + "static/media/no-mobile.f650b4311faca90b32600548033f1333.svg";
export { ForwardRef as ReactComponent };